import Component from '@glimmer/component';

export default class MwEventSidebarRight extends Component {}
